import React from 'react';
import { Col, Row, Input, Select, Button, DatePicker, Spin } from 'antd';
import { connect } from 'react-redux';
import { setPostsData, deletePost, addTextArea, deleteTextArea } from 'actions/postsData';
import moment from 'moment';
moment.locale('ru')

const Post = ({ keyValue, setPostsData, postData, domainsList, deletePost, addTextArea, deleteTextArea, isEditable, isSpinning }) => {
	const { TextArea } = Input;
	const { Option } = Select;

	const handleDeletePost = () => {
		deletePost(keyValue);
	};

	const handleAddTextArea = () => {
		addTextArea(keyValue);
	};

	const handleDeleteTextArea = () => {
		deleteTextArea(keyValue)
	}

	const handleSelectDomain = (val) => {
		const domainObj = domainsList.find(domain => {
			return domain.id === val 
		})
		setPostsData({ ...postData[keyValue], domain: val, domain_name: domainObj.site }, keyValue);
	}

	const handleChangePostData = (date, dateString) => {
		setPostsData({ ...postData[keyValue], post_date: dateString}, keyValue);
	}

	const disabledPostDate = (current) => {
		return current && moment(current).add('day', 1) < moment().endOf('day')
	}

	const defaultDate = postData[keyValue].post_date ? moment(postData[keyValue].post_date, 'YYYY-MM-DD') : null;

	return (
		<Col span={20} className="auto-poster__center-form">
			<Row style={{ margin: '10px' }}>
				<Spin spinning={isSpinning}>
					<Select
						showSearch
						value={postData[keyValue].domain}
						placeholder="Select a domain"
						optionFilterProp="children"
						style={{ width: '100%' }}
						onChange={handleSelectDomain}
						disabled={isEditable}
					>
						{domainsList.map((elem, i) => {
							return (
								<Option value={elem.id} key={i}>
									{elem.site}
								</Option>
							);
						})}
					</Select>
				</Spin>
			</Row>
			<Row className="auto-poster__center-form__bottom">
				{postData[keyValue].textArea.map((elem, i) => {
					return (
						<TextArea
							key={i}
							placeholder="Enter content"
							value={elem}
							style={{ margin: '10px 0' }}
							autoSize={{ minRows: 5 }}
							onChange={(e) => {
								const textAreas = postData[keyValue].textArea;
								textAreas[i] = e.target.value;
								setPostsData({ ...postData[keyValue], textArea: textAreas }, keyValue);
							}}
						/>
					);
				})}

				<DatePicker value = {defaultDate} disabledDate={disabledPostDate} onChange={handleChangePostData} />

				<Row className="auto-poster__center-form__bottom__button-panel">
					<Button onClick={handleAddTextArea} type="primary">
						Add TextArea
					</Button>
					<Button onClick={handleDeleteTextArea} type="danger">
						Delete TextArea
					</Button>
				</Row>
				{postData.length > 1 && (
					<Row className="auto-poster__center-form__bottom__delete-post">
						<Button type="danger" onClick={handleDeletePost}>
							Delete Post
						</Button>
					</Row>
				)}
			</Row>
		</Col>
	);
};

const mapStateToProps = (state) => {
	return {
		postData: state.postsData,
		domainsList: state.domains.domainsList
	};
};

const mapDispatchToProps = (dispatch) => ({
	setPostsData: (data, key) => dispatch(setPostsData(data, key)),
	deletePost: (key) => dispatch(deletePost(key)),
	addTextArea: (key) => dispatch(addTextArea(key)),
	deleteTextArea: (key) => dispatch(deleteTextArea(key))
});

export default connect(mapStateToProps, mapDispatchToProps)(Post);